var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"options":_vm.options,"state":_vm.state},model:{value:(_vm.item.station),callback:function ($$v) {_vm.$set(_vm.item, "station", $$v)},expression:"item.station"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }